import { useAccountManagement, useDeleteAccount } from '@capsicum/socios-core';

export const useDeleteAccountPage = () => {
	const { isDeletionOngoing } = useAccountManagement();

	return {
		...useDeleteAccount(),
		isDeletionOngoing
	};
};
